import { render, staticRenderFns } from "./VideoArticle.vue?vue&type=template&id=7332fb7d&scoped=true&"
import script from "./VideoArticle.vue?vue&type=script&lang=js&"
export * from "./VideoArticle.vue?vue&type=script&lang=js&"
import style0 from "./VideoArticle.vue?vue&type=style&index=0&id=7332fb7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7332fb7d",
  null
  
)

export default component.exports